export default function ScrollDownArrow() {
  const handleClick = () => {
    const nextSection = document.getElementById("services-section");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <button
      onClick={handleClick}
      className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-brand-text-secondary hover:text-brand-gold transition-colors cursor-pointer group z-20"
      aria-label="向下滾動"
    >
      <span className="text-[0.875rem] tracking-wider opacity-70 group-hover:opacity-100 transition-opacity">
        向下探索
      </span>
      <div className="relative w-6 h-10">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1px] h-full bg-brand-border group-hover:bg-brand-gold/50 transition-colors" />
        <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-5 h-5 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-s-line text-xl" />
        </span>
      </div>
    </button>
  );
}